var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopBarProfilo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "top_bar-profilo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0488640934 23.7586681 0.0488640934 23.7586681 23.8074681 0 23.8074681"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "top_bar-profilo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.099909, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7586254,11.9281661 C23.7586254,18.4888939 18.4400608,23.8074681 11.8793447,23.8074681 C5.31852192,23.8074681 -4.27040362e-05,18.4888939 -4.27040362e-05,11.9281661 C-4.27040362e-05,5.36743828 5.31852192,0.0488640934 11.8793447,0.0488640934 C18.4400608,0.0488640934 23.7586254,5.36743828 23.7586254,11.9281661",
    id: "Fill-1",
    fill: "#009846",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.9686354,21.5314697 C8.60301257,21.5314697 5.62783543,19.8082697 3.89105829,17.1965211 C3.93151543,14.5174354 9.27610971,13.0500069 11.9686354,13.0500069 C14.6477211,13.0500069 20.0057554,14.5174354 20.0462126,17.1965211 C18.3094354,19.8082697 15.3342583,21.5314697 11.9686354,21.5314697",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9933211,2.77482514 C14.2314926,2.77482514 16.0380754,4.58154514 16.0380754,6.81957943 C16.0380754,9.05775086 14.2314926,10.8644709 11.9933211,10.8644709 C9.75514971,10.8644709 7.94856686,9.05775086 7.94856686,6.81957943 C7.94856686,4.58154514 9.75514971,2.77482514 11.9933211,2.77482514",
    id: "Fill-6",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBarProfilo);
export default __webpack_public_path__ + "static/media/top_bar-profilo.ebb189c2d957f3c1c3888b5efe3d6467.svg";
export { ForwardRef as ReactComponent };